import { render, staticRenderFns } from "./refundMana.vue?vue&type=template&id=511074c8&scoped=true&"
import script from "./refundMana.vue?vue&type=script&lang=js&"
export * from "./refundMana.vue?vue&type=script&lang=js&"
import style0 from "./refundMana.vue?vue&type=style&index=0&id=511074c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511074c8",
  null
  
)

export default component.exports